module.exports = __webpack_public_path__ + "img/ST.45dc1395.svg";